<template>
    <div :class="transparent ? '' : 'bg-white'">
        <div v-if="images.length > 1" class="slider">
            <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide
                    v-for="item in images"
                    :key="item.id"
                    class="mx-auto"
                >
                    <img v-if="item"
                        :src="`${item.url}?width=1152&${item.crop}`"
                        :alt="item.description"
                        class="mx-auto"
                    />
                    <p
                        v-if="item.description"
                        v-text="item.description"
                        class="text-xs"
                    ></p>
                </swiper-slide>
                <div v-if="images.length > 1" class="swiper-button swiper-button-prev left-1 hidden md:flex border border-gray-400 hover:border-gray-600 hover:bg-white bg-gray-50 p-6 rounded-full text-gray-600 hover:text-gray-900" slot="button-prev"></div>
                <div v-if="images.length > 1" class="swiper-button swiper-button-next right-1 hidden md:flex border border-gray-400 hover:border-gray-600 hover:bg-white  bg-gray-50 p-6 rounded-full text-gray-600 hover:text-gray-900" slot="button-next"></div>
            </swiper>
        </div>
        <div v-else v-epi-edit="'Image'">
            <img v-if ="images"
                :src="`${images[0].url}?width=1152&${images[0].crop}`"
                :alt="images[0].description"
                class="w-full"
            />
            <p
                v-if="images[0].description"
                v-text="images[0].description"
                class="text-xs"
            ></p>
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';

export default {
    name: 'carrousel',
    props: ['images','params','transparent'],
    components: {
        Swiper,
        SwiperSlide
    },
    directives: {
        swiper: directive
    },
    data() {
        return {
            swiperOptions: {
                loop: this.images.length > 1,
                centeredSlides: true,
                effect: 'slide',
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
            }
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper;
        }
    }
};
</script>
